export default function api_teacher(
  state = {
    teacher: null,
    teachers: null,
  },
  action
) {
  switch (action.type) {
    case "FETCH_TEACHERS_SUCCESS":
      return {
        ...state,
        teachers: action.response.data,
      };

    case "REGISTER_TEACHER_SUCCESS":
      return {
        ...state,
        teacher: action.response.data,
      };

    default:
      return state;
  }
}
